import React from 'react';
import { EIconTypes } from 'constants/Icons';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import { SvgIcon } from '@mui/material';
import { colors } from 'theme/colors';
import { IconsSVG } from './icons';

interface IIcon {
  type: EIconTypes;
  color?: string;
  fontSize?: number;
  viewBox?: string;
}

const MUIIcon = (props: SvgIconProps) => <SvgIcon {...props}>{props.children}</SvgIcon>;

const Icon = ({ type, color = colors.primary900, fontSize = 24, viewBox }: IIcon) => {
  const isBoxedIcon = type === EIconTypes.deleteBoxed;
  const iconViewBox = viewBox || (isBoxedIcon ? '0 0 40 40' : '0 0 24 24');

  return IconsSVG[type] ? (
    <MUIIcon sx={{ color, fontSize }} viewBox={iconViewBox}>
      {IconsSVG[type]}
    </MUIIcon>
  ) : null;
};

export default Icon;
